module.exports = __webpack_public_path__ + "static/solution_01-c3efe460034305e25444f512984c06c1.jpg";